import React, { useContext } from "react";

// Material uI imports
import Tooltip from "@material-ui/core/Tooltip";
import HelpIcon from "@material-ui/icons/Help";

// Styling
import "./AddNewClassModals.css";

// global state
import { StateContext } from "../../AppStateContext";

const AddNewPropertyDescriptionInput = ({ propObj, setPropObj }) => {
  // global state
  const state = useContext(StateContext);
  return (
    <div className="__addPropertyDescriptionTextarea">
      <label
        htmlFor="addPropertyDescription"
        style={{ color: state.theme === "dark" ? "#e2e9ff" : " #00152b" }}
      >
        Description
        <Tooltip
          placement="right-start"
          title="An optional description of the property to clarify the meaning, if the name does not covers it fully."
        >
          <HelpIcon
            style={{
              fontSize: "15px",
              color: state.theme === "dark" ? "#848484" : "#5e5e5e",
              cursor: "pointer",
              marginLeft: "6px",
            }}
          />
        </Tooltip>
      </label>
      <textarea
        id="addPropertyDescription"
        cols="10"
        rows="3"
        className={
          state.theme === "dark"
            ? "__addPropertyDescriptionDark"
            : "__addPropertyDescriptionLight"
        }
        value={propObj.description}
        onChange={(e) =>
          setPropObj({ ...propObj, description: e.target.value })
        }
      />
    </div>
  );
};

export default AddNewPropertyDescriptionInput;
